import { useEffect } from "react";
import { useHistory } from "react-router";
import { menu } from "../../menu";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import { useAuth } from "../../utils/AuthHooks";
import { useMaintenance } from "../../utils/MaintenanceHooks";
import Navbar from "./navbar";
import Sidebar from "./sidebar";
import MaintenanceAlert from "../MaintenanceAlert";

export default function MainLayout(props) {
  const { isAuthenticated } = useAuth();
  let history = useHistory();
  const { getPermission } = useControlPermission();
  const { maintenance, message, checkMaintenance } = useMaintenance();

  useEffect(() => {
    if (isAuthenticated === false) {
      history.push("/login");
    }
  }, [isAuthenticated, history]);

  useEffect(() => {
    if (props.resource_key) {
      getPermission(props.resource_key);
    }
  }, [getPermission, props.resource_key]);

  useEffect(() => {
    checkMaintenance();
  }, [checkMaintenance]);

  return (
    <div id="wrapper">
      <Sidebar menu={menu} />
      <div id="content-wrapper" className="d-flex flex-column">
        <div className="content">
          <Navbar />
          {maintenance && <MaintenanceAlert message={message} />}
        </div>
        {props.children}
      </div>
    </div>
  );
}
